
import { Modal } from "antd-mobile/es/components/modal/modal";
import styled from "styled-components";
import { isWeiBo, isWeiXin  } from "../base/util";

import TokenModal from './TokenModal';
import { useState } from "preact/hooks";
const Product = ({
    image,
    title,
    url,
    main_pic,
    couponAmount,
    activityPrice,
    reservePrice,
    taotoken,
    url_scheme
}) => {
    const [visible, setVisible] = useState(false);
    return (
        <Container onClick={()=>{
            if(isWeiBo()){
                let iframe = document.createElement("iframe");
                iframe.style.visibility = "hidden";
                iframe.style.width = 0;
                iframe.style.height = 0;
                iframe.src = url_scheme || src;
                document.body.appendChild(iframe);
                return;
            }
            if(isWeiXin()){
                setVisible(true);
                return;
            }
            window.location.href = url;
        }}>
            <Img src={image || main_pic} loading='lazy'/>
            <Info>
                <div>

                    <Title>
                        {title}
                    </Title>
                    {couponAmount &&<Coupon>
                        {couponAmount}元券
                    </Coupon>}

                </div>
                <PirceContainer>
                    <Left>
                        <Price>¥{activityPrice}</Price>
                        {reservePrice && <Origin>¥{reservePrice}</Origin>}
                    </Left>
                    <Right>
                        <RightText>
                            立即抢购
                        </RightText>
                    </Right>
                </PirceContainer>
            </Info>
            <TokenModal token={taotoken} visible={visible} close={()=> setVisible(false)}/>
        </Container>
    )
}

export default Product;


const Container = styled.div`
    display: flex;
    flex-direction: row;
    padding: 5px 12px;
`;

const Img = styled.img`
    width: 120px;
    height: 120px;
    object-fit: contain;
`;

const Info = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    justify-content: space-between;
    flex: 1;
`;

const Title = styled.div`
    color: #5e5e5e;
    font-size: 14px;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
`;

const Coupon = styled.div`
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAABACAMAAACqVYydAAAAclBMVEUAAAD/VVX/XV3/TmL/SlX/SVv/T1j/TFr/TlX/S1j/S1j/SVb/SVX/SlX/SFf/Slb/SVb/SVb/SVX/SFb/SVb/SVb/SVb/SFb/SVX/SVX/SFX/SVb/SVX/SFX/SVX/SFX/SVX/SFX/SVX/SVb/SFX/SFVTjQgtAAAAJXRSTlMACQsNGBwdJSc6PU1UXWpud4WTlJ6goabAyMnT5Obn7fL7/P3+YYymRAAAAM1JREFUaN7t2lcOwjAURNGhmN6baSaUeP9b5AOB4gUgXcTMCo5k5XkcPSnElKFJMUihyuBUQTGjE5XYwKQMj4EGGmiggQYaaKCB3wVe0LzDTO3lg1unJ5Kk8Q3qO/X0ypzpO3f1zoboq4cfnzpXIHCrRlZAYL8JHNQ4315FjjjgogSuccBRCeRNmlACpzhg68eA+CPGfyT0MYMf1PSrDlkWdg0gvW7RC+v4jq78+EcT/tnpPwsGGmiggQYaaKCB/w3EL/bgV6Pwy2X09bwnHZmhpNJbTzEAAAAASUVORK5CYII=);
    background-size: cover;
    font-size: 12px;
    max-width: 60px;
    color: #fff;
    padding: 5px 5px;
    margin-top: 4px;
`;


const PirceContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 5px;
`;

const Left = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
`;
const Price = styled.div`
    color: #ff4a4a;
    font-size: 18px;
`;
const Origin = styled.div`
    color: #888;
    font-size: 15px;
    text-decoration: line-through;
    margin-left: 5px;
`;
const Right = styled.div`
    background: #ff4855;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 15px;
`;

const RightText = styled.div`
    color: white;
    font-size: 14px;
`;